
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FuseUtils } from '@fuse/utils';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
    selector: 'scrumboard-label-selector',
    templateUrl: './label-selector.component.html',
    styleUrls: ['./label-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class ScrumboardLabelSelectorComponent implements OnInit, OnDestroy {

    empRole = '';
    @Input('Events') eventss: any[];
    events: any[] = [];
    @Output() cardLabelsChanged = new EventEmitter();
    board: any;
    labelsMenuView: string;
    selectedLabel: any;
    newLabel: any;
    toggleInArray: any;
    showSelector: boolean;
    private _unsubscribeAll: Subject<any>;

    constructor(
        private storageConfiguration: StorageConfiguration,
    ) {
        // Set the defaults
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.labelsMenuView = 'labels';
        this.newLabel = {
            'id': '',
            'name': '',
            'color': 'blue-400'
        };
        this.toggleInArray = FuseUtils.toggleInArray;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.showSelector = true;
        if (this.empRole == 'Employee') {
            this.events.push(
                { value: 'Leave', viewValue: 'Leave' }
            );
        }
        if (this.empRole == 'Leader') {
            this.events.push(
                { value: 'Leave', viewValue: 'Leave' },
                { value: 'Meeting', viewValue: 'Meeting' },
            );
        }

        if (this.empRole == 'Admin') {
            this.events.push(
                { value: 'Meeting', viewValue: 'Meeting' },
            );
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    onCardLabelsChanged(): void {
        this.cardLabelsChanged.next();
    }

    typeSelection(val) {
        this.cardLabelsChanged.emit(val);
    }

}


export interface User {
    name: string;
}